import { studentInitials, type Student } from '@td/shared';
import { studentPhotoUrl } from '../hooks/useStudents';
import { usePrivacy } from '../privacy/PrivacyContext';

/**
 * A student's photo, or their initials when there isn't one.
 *
 * Under the privacy screen the photo is blurred rather than swapped out, so
 * the layout doesn't jump and you can still tell the cards apart at a glance.
 */
export function StudentAvatar({
  student,
  size = 56,
  className = '',
}: {
  student: Student;
  size?: number;
  className?: string;
}) {
  const { privacy } = usePrivacy();

  return (
    <span
      className={[
        'inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-sand/60 text-espresso',
        className,
      ].join(' ')}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.34) }}
    >
      {student.hasPhoto ? (
        <img
          src={studentPhotoUrl(student)}
          alt=""
          width={size}
          height={size}
          loading="lazy"
          draggable={false}
          className={[
            'h-full w-full object-cover transition-[filter] duration-200',
            privacy ? 'blur-md' : '',
          ].join(' ')}
        />
      ) : (
        <span aria-hidden>{studentInitials(student)}</span>
      )}
    </span>
  );
}
